/* Reveal Durin portals on descent and reverse the same fade on ascent. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let portals = [];
  const selector = '#MainContent [id$="__collection_list_UMFWwE"] .collection-list__item';
  const reveal = (portal, progress) => {
    portal.progress = Math.min(1, Math.max(0, progress));
    portal.inner.style.setProperty('--tos-durin-hidden', `${(1 - portal.progress) * 100}%`);
  };
  const update = () => {
    frame = 0;
    if (motion.matches) return;
    const scroll = window.scrollY;
    const viewport = window.innerHeight;
    for (const portal of portals) {
      if (portal.item.contains(document.activeElement)) { reveal(portal, 1); continue; }
      const rect = portal.inner.getBoundingClientRect();
      const start = Math.max(0, rect.top + scroll - viewport * .8);
      const distance = Math.max(180, rect.height * .9);
      reveal(portal, Math.min(1, Math.max(0, (scroll - start) / distance)));
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const init = () => {
    portals = [...document.querySelectorAll(selector)].map(item => ({ item, inner: item.querySelector('.card__inner'), progress: 0 })).filter(p => p.inner);
    for (const portal of portals) {
      portal.inner.classList.toggle('tos-durin-reveal', !motion.matches);
      portal.inner.style.setProperty('--tos-durin-hidden', motion.matches ? '0%' : '100%');
      if (!portal.item.dataset.tosDurinFocus) {
        portal.item.dataset.tosDurinFocus = 'true';
        portal.item.addEventListener('focusin', () => {
          const current = portals.find(p => p.item === portal.item);
          if (current) reveal(current, 1);
        });
      }
    }
    schedule();
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  motion.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

